var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"absolute w-full shadow-lg z-1"},[_c('smooth-wrapper',{attrs:{"multiple-children":""}},_vm._l((_vm.notifications),function(notification){return _c('notification',{key:notification.id,attrs:{"notification":notification}})}),1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }